<template>
  <section class="section--comp">
    <div class="container items-center">
      <h3 class="section--h3">Easy to use API</h3>
      <p class="section--p">
        Guide to setup and configuration. You can present below a guide and a
        description of how your system configuration works and add some animated
        screens.
      </p>
      <div>
        <vs-row vs-type="flex">
          <vs-col
            class="sm:w-full lg:w-1/4 p-3"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vx-card class="items-center">
              <div class="items-left mb-base">
                <vs-button type="border" color="primary" @click.stop="codeType='create'">
                    CREATE User
                </vs-button>
                <!-- <h4 class="api-title"><span style="color: green;">Create</span> User</h4> -->
              </div>
              <div class="items-left mb-base" @click.stop="codeType='get'">
                <vs-button type="border" color="success">
                    GET User
                </vs-button>
                <!-- <h4 class="api-title"><span style="color: orange;">Get</span> User</h4> -->
              </div>
              <div class="items-left mb-base" @click.stop="codeType='update'">
                <vs-button type="border" color="warning">
                    UPDATE User
                </vs-button>
                <!-- <h4 class="api-title"><span style="color: blue;">Update</span> User</h4> -->
              </div>
              <div class="items-left mb-base" @click.stop="codeType='delete'">
                <vs-button type="border" color="danger">
                    DELETE User
                </vs-button>
                <!-- <h4 class="api-title"><span style="color: red;">Delete</span> User</h4> -->
              </div>
              <!-- <div class="items-left mb-base p-5">
                <h4 class="api-title">General API Settings</h4>
              </div> -->
            </vx-card>
          </vs-col>
          <vs-col
            class="sm:w-full lg:w-3/4 p-3"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <vx-card class="items-center">
              <div class="vx-card__code-container" ref="codeContainer" :class="{collapsed: false}">
                  <div class="code-content">
                      <prism language="js" :key="$vs.rtl">
                              {{codeSnippet[codeType]}}
                      </prism>
                  </div>
              </div>
            </vx-card>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </section>
</template>

<script>
import Prism from 'vue-prism-component'
export default {
  name: "EasyToUseAPI",
  components: {Prism},
  data() {
    return {
      codeSnippet: {
        'create': `
          async createUser(user) {
              try {
                const resObj = await axios.post('api/users', user);
                return resObj;
              } catch (error) {
                throw error;
              }
          }
        `,
        'get': `
          async getUser(userId) {
            try {
              const resObj = await axios.get('api/users/{userId}');
              return resObj;
            } catch (error) {
              throw error;
            }
          }
        `,
        'update': `
          async updateUser(userId, userDetails) {
            try {
              const resObj = await axios.patch('api/users/{userId}', userDetails);
              return resObj;
            } catch (error) {
              throw error;
            }
          }
        `,
        'delete': `
          async deleteUser(userId) {
            try {
              const resObj = await axios.delete('api/users/{userId}');
              return resObj;
            } catch (error) {
              throw error;
            }
          }
        `
      },
      codeType: 'create'
    }
  }
};
</script>

<style scoped>
.api-title {
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    line-height: 27px;
    color: #231D4F;
    flex: none;
    order: 0;
    flex-grow: 0;
    /*margin: 0px 10px;*/
}

.api-description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
    /*margin: 0px 10px;*/
  }

.con-vs-card {
    height: 100%;
    min-height: 100%;
}
</style>